module.exports = __webpack_public_path__ + "img/FluteMasterLogo.82de2689.png";